import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { DialogService } from 'src/app/services/dialogService/dialog-service';
import { ProductsService } from 'src/app/services/productsService/products.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-products-list',
  templateUrl: './products-list.component.html',
  styleUrls: ['./products-list.component.less']
})
export class ProductsListComponent implements OnInit {
  products;
  env = environment;
  swipConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 8.5,
    spaceBetween: 15,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: true,
    pagination: false,
    slidesOffsetBefore: 64,
    slidesOffsetAfter: 15,
    watchOverflow: true,
    breakpoints: {
      0: {
        slidesPerView: 1.5
      },
      768: {
        slidesPerView: 2.5
      },
      992: {
        slidesPerView: 4.5
      },
      1920: {
        slidesPerView: 5.5
      }
    }
  };

  constructor(private productsService: ProductsService, private dialogService: DialogService) { }

  /** Intialize component  */
  ngOnInit(): void {
    this.products = new Array();
    this.getData();
  }

  /** Get Products Data */
  getData() {
    this.productsService.getProducts().then((resp: any) => {
      resp.data.products.map(obj => {
        obj.definition = this.productsService.getDefinitions(obj.rendition);
      });
      // It means that the user doesn't have any package so he could select a pack. Coupons logic
      if (!resp.data.products.find(obj => obj.isSubscribed)) {
        this.products = resp.data.products;
      }
    });
  }

  /** Subscribe into a product */
  subscribe(product) {
    this.productsService.subscribeSingleProduct(product).then(resp => {
      if (resp) {
        location.hash = "";
      }
    });
  }

  /** Cancel Subscription */
  cancelSubscription(product) {
    this.dialogService.openConfirmDialog({
      title: "gen_cancel_subscription",
      message: "info_cancel_subscription_msg",
      confirm: "gen_ok",
      cancel: "gen_cancel"
    }).subscribe(result => {
      if (result) {
        this.productsService.cancelProduct({ productId: product.subscriptionId }).then((resp: any) => {
          this.ngOnInit();
        });
      }
    });
  }

  /** Move to home  */
  startWatching() {
    location.hash = "";
  }
}